import React from 'react';
import type { DocumentType } from '../../../graphql/generated/gql';
import { gql } from '../../../graphql/generated/gql';
import { externalEditText } from '../../../utils/post/externalPost';
import { editIcon } from '../editorIcons';
import ToolbarButton, { ToolbarButtonGroup } from './buttons/ToolbarButton';

const EXTERNAL_POST_FRAGMENT = gql(`
  # eslint-disable-next-line @graphql-eslint/require-selections
  fragment ImportedToolbar_externalPost on ExternalPost {
    editUrl
    platform
  }
`);

interface ImportedToolbarProps {
  externalPost: DocumentType<typeof EXTERNAL_POST_FRAGMENT>;
}

const ImportedToolbar = ({
  externalPost: { editUrl, platform },
}: ImportedToolbarProps) => (
  <ToolbarButtonGroup>
    <ToolbarButton to={editUrl} newTab icon={editIcon}>
      {externalEditText(platform)}
    </ToolbarButton>
  </ToolbarButtonGroup>
);

export default ImportedToolbar;
